import { useQuery } from "react-query";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import { AxiosError } from "axios";
import { useRecoilState, useSetRecoilState } from "recoil";
import { photoFetchStatusState, fotoProfileUrlState } from "../../../../recoil/UserFotoProfileState";
import { setProfilePhotoInStorage } from "../../../../utils/photoStorage";

export const fileFotoKey = "file-foto-key";

const isFileNotFoundError = (error: unknown): boolean => {
  const err = error as AxiosError;
  if (!err.response) {
    return false;
  }
  if (err.response.status !== 400) {
    return false;
  }
  let responseText = '';
  const responseData = err.response.data;
  if (responseData instanceof ArrayBuffer) {
    try {
      responseText = new TextDecoder().decode(responseData);
    } catch (e) {
      return false;
    }
  } else if (typeof responseData === 'string') {
    responseText = responseData;
  }
  return responseText.trim() === "File Not Found";
};



async function fetchFotoProfileAPI(): Promise<ArrayBuffer | null> {
  try {
    const res = await ApiClient.get(`/ViewFile?id=Foto`, {
      responseType: "arraybuffer",
      // validateStatus: (status) => {
      //   return status >= 200 && status < 500;
      // },
    });
    // if (res.status >= 400) {
    //   return null;
    // }
    return res.data;
  } catch (error) {
    if (isFileNotFoundError(error)) {
      return null;
    }
    throw error;
  }
}

export default function useFetchFotoProfile() {
  const [fetchStatus, setFetchStatus] = useRecoilState(photoFetchStatusState);
  const setFotoProfileUrl = useSetRecoilState(fotoProfileUrlState);

  return useQuery([fileFotoKey], fetchFotoProfileAPI, {

    enabled: fetchStatus === 'idle' || fetchStatus === 'success',

    onSuccess: (data) => {
      if (data) {
        const dataUrl = setProfilePhotoInStorage(data);
        setFotoProfileUrl(dataUrl);
        setFetchStatus('success');
      } else {
        setFetchStatus('failed');
      }
    },
    onError: (error) => {
      // const err = error as AxiosError;
      // if (err.response && err.response.status >= 400 && err.response.status < 500) {
      //   setFetchStatus('failed');
      // }
    },
    // retry: (failureCount, error) => {
    //   if (isFileNotFoundError(error)) {
    //     return false;
    //   }
    //   return failureCount < 4;
    // },
    retry: true,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
}